exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".icon-info-informe {\n  position: relative;\n  left: 0px;\n  top: 2px;\n  cursor: pointer; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/adri9/Escritorio/admin-everpath/src/app/componentes/CoincidenciasChart/coincidenciasChart.component.scss
// module id = ../../../../../src/app/componentes/CoincidenciasChart/coincidenciasChart.component.scss
// module chunks = main